export const createSeasonStatData = (ids, data) => ({
  ...ids,
  ...data,
});
